import {Transaction} from "@/types";
import {Table, TableBody, TableCell, TableColumn, TableHeader, TableRow} from "@heroui/table";
import {useQuery} from "@tanstack/react-query";
import {createFileRoute} from '@tanstack/react-router'
import React from "react";
import Content from "../../../components/Content.tsx";
import Header from "../../../Header.tsx";
import services from "../../../services";
import queryKeys from "../../../utilities/queryKeys.ts";

export const Route = createFileRoute('/_app/master/transactions')({
    component: RouteComponent,
})

function RouteComponent() {
    const transactionsQuery = useQuery<any[]>({
        queryKey: queryKeys.admin.transactions(),
        queryFn:  services.admin.transactions,
    })

    const transactions = (transactionsQuery.data?.[0] ? transactionsQuery.data : []);

    return (
        <div>
            <Header />
            <Content>
                <Table aria-label="Transactions list" classNames={{wrapper: "p-1", th: "px-1 text-center", td: "px-1 py-1 text-center"}}
                       isVirtualized={true}
                       isStriped={true}
                       isHeaderSticky={true}>
                    <TableHeader>
                        <TableColumn>User</TableColumn>
                        <TableColumn>Transaction</TableColumn>
                        <TableColumn>Status</TableColumn>
                        <TableColumn>Purpose</TableColumn>
                    </TableHeader>
                    <TableBody>
                        {transactions.map((transaction: Transaction) => (
                            <TableRow key={transaction.uid}>
                                <TableCell className="text-left pl-2">
                                    <div>
                                        ID: {transaction.uid}<br />
                                        {transaction.user?.name || 'NONAME'} ({transaction.user?.email})<br />
                                        {transaction.created_at.replace('T', ' ').replace(/\..*/, '')}
                                    </div>
                                </TableCell>
                                <TableCell className={"whitespace-pre"}>
                                    {transaction.product?.name}<br />
                                    {!!transaction.payment_gateway && <span>{transaction.payment_gateway}:</span>} {transaction.amount_cents / 100} {transaction.currency_code}
                                </TableCell>
                                <TableCell className={"whitespace-pre"}>
                                    {transaction.status}
                                </TableCell>
                                <TableCell className={"whitespace-pre"}>
                                    {transaction.purpose}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                {transactionsQuery.data?.length === 0 && (
                    <div>No transactions found.</div>
                )}

            </Content>
            {/*<pre>
                {JSON.stringify(transactionsQuery.data?.[1], null, 2)}
            </pre>*/}
        </div>
    )
}
